Box details: <button class="nrk-button ml-2 mr-4" (click)="boxDetails.show()">open</button>
<!-- why stuck with below code? -->
<!-- Box summary: <b class="pl-2">Σ Boxes:</b> {{this.spoBoxes.length}}<span class="pl-3 pr-3" [ngStyle]="getBoxQuantity() !== lineItem.quantity && {'background-color': '#e55'}"><b>Σ Quantity:</b> {{getBoxQuantity()}}</span> -->

<nrk-window #boxDetails [style]="{ width: 'fit-content' }" (onClose)="onClose()">

    <nrk-header><b>Box Details</b></nrk-header>

    <nrk-content>
        Box type: <span style="width:10em;display:inline-block"><ngx-doc-form-dropdown class="fullwidth" placeholder="Type of Box" [value]="boxType" (valueChange)="boxTypeChanged($event)" [options]="boxTypeOptions" [disabled]="disabled"></ngx-doc-form-dropdown></span>
        <input class="ml-4 mr-4" type="text" placeholder="Paste box data" (paste)="onPasteBoxData($event)" [attr.disabled]="disabled || null"/>
        <button *ngIf="!disabled" class="nrk-button ml-4" (click)="removeAll()">remove all</button>
        <table class="mt-2">
            <td>
                <table class="nrk-table">
                    <tr>
                        <!-- <th *ngIf="!disabled"><button class="nrk-doc-button" (click)="addItem()">+</button></th> -->
                        <th *ngIf="!disabled"></th>
                        <th *ngIf="!disabled"><button class="nrk-button" (click)="addItem();editLine=lineItem.boxDetails[lineItem.boxDetails.length - 1]"> + </button></th>
                        <th>Box Id</th>
                        <th>Case #</th>
                        <th>OBIC</th>
                        <th>Article</th>
                        <th>Dimension</th>
                        <th>Lot #</th>
                        <th>Quantity</th>
                        <th>TC</th>
                        <th>Date of TC</th>
                        <th>Box Name</th>
                        <th>L x W x H (cm)</th>
                        <th>Gross Weight</th>
                        <th>Net Weight</th>
                        <th>Date of Prod</th>
                        <th>Expiry Date</th>
                        <th>Joints</th>
                        <th>Type of Box</th>
                    </tr>
                    <tr *ngFor="let item of lineItem.boxDetails">
                        <!-- <td *ngIf="!disabled"><button class="nrk-doc-button" (click)="removeItem(item)">-</button></td> -->
                        <td *ngIf="!disabled"><button class="nrk-button" (click)="removeItem(item)">X</button></td>
                        <td *ngIf="!disabled && editLine !== item"><button class="nrk-button" (click)="editLine=item;">✎</button></td>
                        <td *ngIf="!disabled && editLine === item"><button class="nrk-button" (click)="editLine=null;">✎</button></td>
                        <td>{{item.boxId | nrkPad : 6}}</td>
                        <ng-container *ngIf="editLine !== item || disabled">
                            <td>{{item.case}}</td>
                            <td>{{item.obic}}</td>
                            <td>{{item.article}}</td>
                            <td>{{item.dimension}}</td>
                            <td>{{item.lot}}</td>
                            <td>{{item.quantity}}</td>
                            <td>{{item.tc}}</td>
                            <td>{{item.tcDate}}</td>
                            <td>{{item.boxName}}</td>
                            <td>{{item.lwh}}</td>
                            <td>{{item.grossWeight}}</td>
                            <td>{{item.netWeight}}</td>
                            <td>{{item.prodDate}}</td>
                            <td>{{item.expiryDate}}</td>
                            <td>{{item.joints}}</td>
                            <td>{{item.boxType}}</td>
                        </ng-container>
                        <ng-container *ngIf="editLine === item && !disabled">
                            <td><ngx-doc-form-texfield class="fullwidth" placeholder="Case #" [(value)]="item.case" (valueChange)="updateSummary()" [disabled]="disabled"></ngx-doc-form-texfield></td>
                            <td><ngx-doc-form-texfield class="fullwidth" placeholder="OBIC" [(value)]="item.obic" (valueChange)="updateSummary()" [disabled]="disabled"></ngx-doc-form-texfield></td>
                            <td><ngx-doc-form-texfield class="fullwidth" placeholder="Article" [(value)]="item.article" (valueChange)="updateSummary()" [disabled]="disabled"></ngx-doc-form-texfield></td>
                            <td><ngx-doc-form-texfield class="fullwidth" placeholder="Dimension" [(value)]="item.dimension" (valueChange)="updateSummary()" [disabled]="disabled"></ngx-doc-form-texfield></td>
                            <td><ngx-doc-form-texfield class="fullwidth" placeholder="Lot #" [(value)]="item.lot" (valueChange)="updateSummary()" [disabled]="disabled"></ngx-doc-form-texfield></td>
                            <td><ngx-doc-form-texfield class="fullwidth" placeholder="Quantity" mode="integer" [(value)]="$any(item).quantity" (valueChange)="updateSummary()" [disabled]="disabled"></ngx-doc-form-texfield></td>
                            <td><ngx-doc-form-texfield class="fullwidth" placeholder="Test Report #" [(value)]="item.tc" (valueChange)="updateSummary()" [disabled]="disabled"></ngx-doc-form-texfield></td>
                            <td><ngx-doc-form-date class="fullwidth" placeholder="Date of TC" [(value)]="$any(item).tcDate" (valueChange)="updateSummary()" [disabled]="disabled"></ngx-doc-form-date></td>
                            <td><ngx-doc-form-texfield class="fullwidth" placeholder="Box Name" [(value)]="item.boxName" (valueChange)="updateSummary()" [disabled]="disabled"></ngx-doc-form-texfield></td>
                            <td><ngx-doc-form-texfield class="fullwidth" placeholder="L x W x H (cm)" [(value)]="item.lwh" (valueChange)="updateSummary()" [disabled]="disabled"></ngx-doc-form-texfield></td>
                            <td><ngx-doc-form-texfield class="fullwidth" placeholder="Gross Weight" mode="float" [(value)]="$any(item).grossWeight" (valueChange)="updateSummary()" [disabled]="disabled"></ngx-doc-form-texfield></td>
                            <td><ngx-doc-form-texfield class="fullwidth" placeholder="Net Weight" mode="float" [(value)]="$any(item).netWeight" (valueChange)="updateSummary()" [disabled]="disabled"></ngx-doc-form-texfield></td>
                            <td><ngx-doc-form-date class="fullwidth" placeholder="Date of Prod" [(value)]="$any(item).prodDate" (valueChange)="updateSummary()" [disabled]="disabled"></ngx-doc-form-date></td>
                            <td><ngx-doc-form-date class="fullwidth" placeholder="Expiry Date" [(value)]="$any(item).expiryDate" (valueChange)="updateSummary()" [disabled]="disabled"></ngx-doc-form-date></td>
                            <td><ngx-doc-form-texfield class="fullwidth" placeholder="Joints" [(value)]="item.joints" (valueChange)="updateSummary()" [disabled]="disabled"></ngx-doc-form-texfield></td>
                            <td><ngx-doc-form-dropdown class="fullwidth" placeholder="Type of Box" [(value)]="item.boxType" (valueChange)="boxTypeChanged($event)" [options]="boxTypeOptions" [disabled]="disabled"></ngx-doc-form-dropdown></td>
                        </ng-container>
                    </tr>
                </table>
            </td>
            <td class="pl-2" style="vertical-align:top" *ngIf="spoBoxes?.length">
                Box summary:
                <p>
                    <b>Σ Boxes:</b> {{this.spoBoxes.length}}<br>
                    <span [ngStyle]="getBoxQuantity() !== lineItem.quantity && {'background-color': '#e55'}"><b>Σ Quantity:</b> {{getBoxQuantity()}}</span>
                </p>
                <table class="nrk-table">
                    <tr>
                        <th>Box ID</th>
                        <th>Case #</th>
                        <th>Quantity</th>
                        <th>Status</th>
                    </tr>
                    <tr *ngFor="let item of spoBoxes">
                        <td class="text-right">{{item.boxId | nrkPad : 6}}</td>
                        <td class="text-right">{{item.case | nrkPad : 3}}</td>
                        <td class="text-right">{{item.quantity}}</td>
                        <td class="text-right">{{boxStatus[item.status]}}</td>
                    </tr>
                </table>
        
                <!-- <div class="mt-3">
                    <button *ngIf="!disabled" class="nrk-button" (click)="removeAll()">remove all</button>
                </div> -->
                <!-- <button class="nrk-button mt-2" (click)="commitBoxes()">Confirm data</button> -->
            </td>  
        </table>
    </nrk-content>

    <nrk-footer>
        <button class="nrk-button" (click)="boxDetails.hide()">close</button>
        <button *ngIf="compilation" class="nrk-button ml-4" (click)="save()">save</button>
        <button *ngIf="compilation" class="nrk-button ml-4" (click)="init()">update</button>
    </nrk-footer>

</nrk-window>




<!-- <span>{{show ? '▼' : '▶'}} </span> -->
<!-- Box details: <button class="nrk-button ml-2 mr-4" (click)="show = !show">{{show ? 'hide' : 'show'}}</button>
Box type: <span style="width:10em;display:inline-block"><ngx-doc-form-dropdown class="fullwidth" placeholder="Type of Box" [value]="boxType" (valueChange)="boxTypeChanged($event)" [options]="boxTypeOptions" [disabled]="disabled"></ngx-doc-form-dropdown></span>
<input class="ml-4 mr-4" type="text" placeholder="Paste box data" (paste)="onPasteBoxData($event)" />


<div *ngIf="show" class="mt-2" style="display:flex;flex-wrap:wrap">
    <div>
        <table class="nrk-table" style="max-width:50rem">
            <tr>
                <th *ngIf="!disabled"><button class="nrk-doc-button" (click)="addItem()">+</button></th>
                <th>Box Id</th>
                <th>Case #</th>
                <th>Production Lot</th>
                <th>Date of Prod</th>
                <th>TC</th>
                <th>Date of TC</th>
                <th>Type of Box</th>
                <th>Quantity</th>
                <th>Joints</th>
            </tr>
            <tr *ngFor="let item of lineItem.boxDetails">
                <td *ngIf="!disabled"><button class="nrk-doc-button" (click)="removeItem(item)">-</button></td>
                <td>{{item.boxId | nrkPad : 6}}</td>
                <td><ngx-doc-form-texfield class="fullwidth" placeholder="Case #" [(value)]="item.case" (valueChange)="updateSummary()" [disabled]="disabled"></ngx-doc-form-texfield></td>
                <td><ngx-doc-form-texfield class="fullwidth" placeholder="No. of Production Lot" [(value)]="item.lot" (valueChange)="updateSummary()" [disabled]="disabled"></ngx-doc-form-texfield></td>
                <td><ngx-doc-form-date class="fullwidth" placeholder="Date of Prod" [(value)]="$any(item).prodDate" (valueChange)="updateSummary()" [disabled]="disabled"></ngx-doc-form-date></td>
                <td><ngx-doc-form-texfield class="fullwidth" placeholder="Test Certificate" [(value)]="item.tc" (valueChange)="updateSummary()" [disabled]="disabled"></ngx-doc-form-texfield></td>
                <td><ngx-doc-form-date class="fullwidth" placeholder="Date of TC" [(value)]="$any(item).tcDate" (valueChange)="updateSummary()" [disabled]="disabled"></ngx-doc-form-date></td>
                <td><ngx-doc-form-dropdown class="fullwidth" placeholder="Type of Box" [(value)]="item.boxType" (valueChange)="boxTypeChanged($event)" [options]="boxTypeOptions" [disabled]="disabled"></ngx-doc-form-dropdown></td>
                <td><ngx-doc-form-texfield class="fullwidth" placeholder="Quantity" mode="integer" [(value)]="$any(item).quantity" (valueChange)="updateSummary()" [disabled]="disabled"></ngx-doc-form-texfield></td>
                <td><ngx-doc-form-texfield class="fullwidth" placeholder="Joints" [(value)]="item.joints" (valueChange)="updateSummary()" [disabled]="disabled"></ngx-doc-form-texfield></td>
            </tr>
        </table>
    </div>
    <div class="ml-4" *ngIf="spoBoxes?.length">
        Box summary:
        <p>
            <b>Σ Boxes:</b> {{this.spoBoxes.length}}<br>
            <span [ngStyle]="getBoxQuantity() !== lineItem.quantity && {'background-color': '#e55'}"><b>Σ Quantity:</b> {{getBoxQuantity()}}</span>
        </p>
        <table class="nrk-table">
            <tr>
                <th>Box ID</th>
                <th>Case #</th>
                <th>Quantity</th>
                <th>Status</th>
            </tr>
            <tr *ngFor="let item of spoBoxes">
                <td class="text-right">{{item.boxId | nrkPad : 6}}</td>
                <td class="text-right">{{item.case | nrkPad : 3}}</td>
                <td class="text-right">{{item.quantity}}</td>
                <td class="text-right">{{boxStatus[item.status]}}</td>
            </tr>
        </table>

        <div class="mt-3">
            <button *ngIf="!disabled" class="nrk-button" (click)="removeAll()">remove all</button>
        </div>
    </div>
</div> -->